import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  SearchRequest,
  SearchResponse,
  SelectedFacets,
  SimpleNavigation,
  SimpleRefinementItem,
  SortOptions,
} from '@usf/product-types';
import { Subscription } from 'rxjs';
import { SearchFilterService } from '../../services/search-filter.service';
import { FilterRequestModel } from '../../shared/models/filter-request-model';
import { RangeRefinementItem } from '../../shared/models/range-refinement-item-model';
import { SearchFilterEnum } from '../../shared/models/search-filter.enum';
import { SearchViewModel } from '../../shared/models/search-view.model';
import { isValidRefinement } from '../../utils/search-filter.util';
import { FILTER_MODAL_ACTION_TYPE } from '@search/models/search-filter.constants';
import { SearchFilterSelected } from '@search/shared/models/search-filter-selected';

@Component({
  template: '',
})
export class SearchFiltersBaseComponent implements OnInit, OnDestroy {
  @Input() searchViewModel: SearchViewModel;
  @Input() selectedFilter: any;
  @Input() filtersFormGroup: UntypedFormGroup;
  @Input() type: SearchFilterEnum;
  @Input() totalRecords: number;
  @Input() navigation: SimpleNavigation[];
  @Input() selectedFacets: SelectedFacets;
  @Input() searchRequest: SearchRequest;
  @Input() searchResponse: SearchResponse;
  @Input() showSort?: boolean;
  @Output()
  selectFilterOption: EventEmitter<FilterRequestModel> = new EventEmitter();
  rangeWithUOMRefinements: RangeRefinementItem[];
  filterRefinements: SimpleRefinementItem[];
  numberOfSelectedFilters$: Subscription;
  numberOfSelectedFilters: { [key: string]: number | string };
  timer: any;
  searchEnum = SearchFilterEnum;
  requestQueryParam: Params;

  constructor(
    protected modalController: ModalController,
    protected router: Router,
    protected searchFilterService: SearchFilterService,
    protected renderer: Renderer2,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.requestQueryParam = params;
    });

    this.numberOfSelectedFilters$ = this.searchFilterService
      .getFilterRefinementMap(this.searchViewModel?.searchRequest)
      ?.subscribe((map: { [key: string]: number | string }) => {
        this.numberOfSelectedFilters = {};
        Object.keys(map).forEach(k => {
          if (map[k]?.toString().indexOf('|') > -1) {
            const count = map[k].toString().split('|')[0];
            const selectedValue = map[k].toString().split('|')[1];
            this.numberOfSelectedFilters[k] =
              selectedValue.length < 52 ? selectedValue : +count;
          } else {
            this.numberOfSelectedFilters[k] = map[k];
          }
        });
      });
  }

  async dismissModal() {
    await this.modalController.dismiss(
      FILTER_MODAL_ACTION_TYPE.DESKTOP_DISMISS,
    );
  }

  setSelectedFilter = filter => {
    this.selectedFilter = filter;
    // range refinement format
    this.rangeWithUOMRefinements = this.selectedFilter?.rangeRefinements?.map(
      (r: SimpleRefinementItem) =>
        ({
          ...r,
          displayName: this.extractDisplayNameAndUOM(r.displayName)[0],
          uom: this.extractDisplayNameAndUOM(r.displayName)[1],
        } as RangeRefinementItem),
    );
    this.filterRefinements = this.selectedFilter?.refinements?.filter(r =>
      isValidRefinement(
        this.searchViewModel?.searchRequest?.searchFilterProperties,
        this.selectedFilter,
        r,
      ),
    );
  };

  clickCheckBox(item: SimpleRefinementItem, categoryLink: boolean) {
    const searchFilterSelected: SearchFilterSelected = {
      filterNav: this.selectedFilter,
      refinementItem: item,
    };
    this.searchFilterService.trackClickedSearchFilter(searchFilterSelected);
  }

  async apply() {
    this.selectedFilter = null;
    await this.modalController.dismiss(FILTER_MODAL_ACTION_TYPE.CONFIRM);
  }

  async clearAll() {
    this.selectedFilter = null;
    await this.modalController.dismiss(FILTER_MODAL_ACTION_TYPE.TOUCH_CLEAR);
  }
  getImageUrl(filter: SimpleRefinementItem): string {
    if (filter.name === '1 Star & Up') {
      return 'assets/images/1-star-rating.svg';
    } else if (filter.name === '2 Stars & Up') {
      return 'assets/images/2-star-rating.svg';
    } else if (filter.name === '3 Stars & Up') {
      return 'assets/images/3-star-rating.svg';
    } else if (filter.name === '4 Stars & Up') {
      return 'assets/images/4-star-rating.svg';
    } else if (filter.name === '5 Stars') {
      return 'assets/images/5-star-rating.svg';
    } else {
      return '';
    }
  }

  extractDisplayNameAndUOM = (s: string): string[] => {
    const parts: string[] = s.split('(');
    const displayName = parts[0];
    const uom = parts[1]?.substring(0, parts[1]?.indexOf(')')) || 'kcal';
    return [displayName, uom];
  };

  isNumber(s: string | number): boolean {
    return typeof s === 'number';
  }

  ngOnDestroy(): void {
    this.numberOfSelectedFilters$?.unsubscribe();
  }
}
